import { Country, isFieldErrorResponse, useApiTransportPricesV1TransitTimeEstimateCreate } from 'api';
import { useFormContext } from 'form';

export const useTransitTimeEstimator = () => {
  const form = useFormContext();
  const { setValue, getValues, setError, clearErrors } = form;

  const clearTransitTimeErrors = () => {
    clearErrors('transit_time_estimate');
    clearErrors('missing_transit_time_estimate');
  };

  const { mutate: createTransitTimeEstimate } = useApiTransportPricesV1TransitTimeEstimateCreate({
    mutation: {
      onError(error) {
        setValue('transit_time_estimate', null);
        clearTransitTimeErrors();
        const errorMessages: string[] = [];
        if (error.status === 422) {
          setError('missing_transit_time_estimate', {});
        } else {
          if (isFieldErrorResponse(error)) {
            Object.keys(error.response?.data).forEach((field) => {
              errorMessages.push(error.response.data[field]);
            });
          }
          setError('transit_time_estimate', {
            message: errorMessages.join(', ') || 'An error occurred while trying to fetch the transit time estimate',
          });
        }
      },
      async onSuccess(data) {
        clearTransitTimeErrors();
        setValue('transit_time_estimate', data);
        setValue('estimated_transit_time_days', data.estimated_transit_days_collection_to_final_delivery);
      },
    },
  });

  const estimateTransitTime = () => {
    const values = getValues();
    const originAddress = values.origin_address;
    const destinationAddress = values.destination_address;

    if (
      (originAddress && destinationAddress) ||
      (values.supply_incoterm &&
        values.demand_incoterm &&
        (originAddress || values.port_of_loading) &&
        (destinationAddress || values.port_of_discharge))
    ) {
      createTransitTimeEstimate({
        data: {
          demand_incoterm: values.demand_incoterm,
          destination: destinationAddress
            ? {
                country: (destinationAddress.country_code as Country) || '',
                lat: destinationAddress.latitude || 0,
                lon: destinationAddress.longitude || 0,
              }
            : undefined,
          origin: originAddress
            ? {
                country: (originAddress.country_code as Country) || '',
                lat: originAddress.latitude || 0,
                lon: originAddress.longitude || 0,
              }
            : undefined,
          port_of_discharge_id: values.port_of_discharge || undefined,
          port_of_loading_id: values.port_of_loading || undefined,
          supply_incoterm: values.supply_incoterm,
        },
      });
    }
  };

  return { estimateTransitTime };
};
